import { RootState } from "../store/store";

export const sessionSelector = (state: RootState) => state.session;
